/**
 * @public
 * Default data structure.
 */
const defaultPhone = {
  site: null,
  src: null,
  state: null,
  gclid: null,
  ircid: null,
  btsid: null,
  hcsid: null,
  device: null,
  goal_url: null,
  requesturl: null,
  placement: null,
  channel: null,
  domain: null,
  subid: null,
};

export default defaultPhone;
